import { assert } from 'common/helpers'
import type { Nullable } from 'common/types'
import { createContext, useContext } from 'react'

import type { LegendContextType } from './types'

export const LegendContext = createContext<Nullable<LegendContextType>>(null)

export const useLegendContext = (): LegendContextType => {
  const context = useContext(LegendContext)

  assert(context !== null, 'Trying to use LegendContext out of Legend component')

  return context
}
